import '@phrmpc/assets/styles/index.scss';
import { FC } from 'react';
import AppRoutes from './routing';
import { ErrorBoundary } from 'react-error-boundary';

const AppCrashedFallback = () => (
  <div style={{ padding: 32 }}>
    <h1>Something went wrong.</h1>
    <p>The application has crashed. Please refresh the page.</p>
  </div>
);

const App: FC = () => (
  <ErrorBoundary FallbackComponent={AppCrashedFallback}>
    <AppRoutes />
  </ErrorBoundary>
);

export default App;
